import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=617dbb7c&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=ts&"
export * from "./gift.vue?vue&type=script&lang=ts&"
import style0 from "./gift.vue?vue&type=style&index=0&id=617dbb7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617dbb7c",
  null
  
)

export default component.exports